import { render } from "./SeStdTaxFormW2.vue?vue&type=template&id=61b5912a"
import script from "./SeStdTaxFormW2.vue?vue&type=script&lang=js"
export * from "./SeStdTaxFormW2.vue?vue&type=script&lang=js"

import "./SeStdTaxFormW2.vue?vue&type=style&index=0&id=61b5912a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__